import React from 'react';
import { Form, Button, Spinner, Row, Col, Accordion } from 'react-bootstrap';
import { useSearch } from '../context/SearchContext';

function SearchSection() {
  const { 
    searchTerm, 
    setSearchTerm, 
    performSearch, 
    isLoading, 
    databaseIsLoading,
    searchInputRef,
    setActiveView,
    searchLog
  } = useSearch();

  return (
    <>
      <SearchFormInput 
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        performSearch={performSearch}
        isLoading={isLoading}
        databaseIsLoading={databaseIsLoading}
        searchInputRef={searchInputRef}
        setActiveView={setActiveView}
      />
      <DebugLog searchLog={searchLog} />
    </>
  );
}

function SearchFormInput({ 
  searchTerm, 
  setSearchTerm, 
  performSearch, 
  isLoading, 
  databaseIsLoading,
  searchInputRef,
  setActiveView
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    performSearch(searchTerm);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowRight') {
      const input = searchInputRef.current;
      if (
        input &&
        input.selectionStart === input.value.length &&
        input.selectionEnd === input.value.length
      ) {
        e.preventDefault();
        setActiveView('results');
      }
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={10}>
          <Form.Control
            ref={searchInputRef}
            type="text"
            placeholder="Search The Urantia Papers"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="none"
            spellCheck="false"
            className="h-100"
          />
        </Col>
        <Col md={2}>
          {(isLoading || databaseIsLoading) ? (
            <div className="d-flex align-items-center justify-content-center w-100 h-100">
              <Spinner animation="border" size="sm" className="me-2" />
              <span>Wait...</span>
            </div>
          ) : (
            <Button 
              variant="primary" 
              type="submit"
              disabled={!searchTerm.trim()}
              className="w-100"
            >
              Search
            </Button>
          )}
        </Col>
      </Row>
    </Form>
  );
}

function DebugLog({ searchLog }) {
  if (!searchLog) return null;
  
  return (
    <div className="mt-3">
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Search Debug Information</Accordion.Header>
          <Accordion.Body>
            <pre className="search-log-pre" style={{ whiteSpace: 'pre-wrap', fontSize: '0.85rem' }}>
              {searchLog}
            </pre>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default SearchSection;
